import { Input as InputPrimitive } from '@base-ui/react/input'

import { cn } from '../../lib/utils'
import type { InputProps } from './types'

export type { InputProps }

function Input({
  className,
  type,
  secureTextEntry,
  onChangeText,
  onChange,
  onBlur,
  ...props
}: InputProps & Omit<React.ComponentProps<'input'>, keyof InputProps>) {
  const resolvedType = type ?? (secureTextEntry ? 'password' : undefined)

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    onChange?.({ target: { value: e.target.value } })
    onChangeText?.(e.target.value)
  }

  return (
    <InputPrimitive
      type={resolvedType}
      data-slot="input"
      onChange={handleChange}
      onBlur={onBlur as React.FocusEventHandler<HTMLInputElement>}
      className={cn(
        'h-8 w-full min-w-0 rounded-md border border-input bg-transparent px-2.5 py-1 text-xs transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-xs file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-1 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-1 aria-invalid:ring-destructive/20 md:text-xs dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40',
        className,
      )}
      {...props}
    />
  )
}

export { Input }
